import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import {
  SmsWarningModule,
  ChatCounterModule,
  FormValidationModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { ChatPartyComponent } from './chat-party.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';

@NgModule({
  declarations: [ChatPartyComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FrontendIconsModule,
    ChatCounterModule,
    SmsWarningModule,
    NgbModule,
    NgSelectModule,
    FormValidationModule,
    UtilsModule,
    FrontendDropdownModule,
    FrontendModalModule,
  ],
  exports: [ChatPartyComponent],
})
export class ChatPartyModule {}
